import React, { Component } from 'react';
import {Grid, Button,TextField} from "@material-ui/core";
import axios from "axios";
import FormatBoldIcon from '@material-ui/icons/FormatBold';
import FormatItalicIcon from '@material-ui/icons/FormatItalic';
import FormatUnderlinedIcon from '@material-ui/icons/FormatUnderlined';
import FormatAlignRightIcon from '@material-ui/icons/FormatAlignRight';
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import FormatAlignCenterIcon from '@material-ui/icons/FormatAlignCenter';
import FormatColorFillIcon from '@material-ui/icons/FormatColorFill';
import TextFormatIcon from '@material-ui/icons/TextFormat';
import TextRotateVerticalIcon from '@material-ui/icons/TextRotateVertical';
import ImageIcon from '@material-ui/icons/Image';
import UndoIcon from '@material-ui/icons/Undo';
import RedoIcon from '@material-ui/icons/Redo';
import Navbar from "../NAV/Navbar"

class Editor extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            title:"",
            openingText:"",
            fontSize:2,
            Series:""
         }
        this.handleBold=this.handleBold.bind(this);
        this.handleItalics=this.handleItalics.bind(this);
        this.handleUnderline=this.handleUnderline.bind(this);
        this.handleJustifyLeft=this.handleJustifyLeft.bind(this);
        this.handleJustifyCentre=this.handleJustifyCentre.bind(this);
        this.handleJustifyRight=this.handleJustifyRight.bind(this);
        this.handleCut=this.handleCut.bind(this);
        this.handleUndo=this.handleUndo.bind(this);
        this.handleRedo=this.handleRedo.bind(this);
        this.handleTitleChange=this.handleTitleChange.bind(this);
        this.handleSubmitPost=this.handleSubmitPost.bind(this);
        this.handleOpenTextChange=this.handleOpenTextChange.bind(this);
        this.handleColorChange=this.handleColorChange.bind(this);
        this.handleDecreaseFontSize=this.handleDecreaseFontSize.bind(this);
        this.handleIncreaseFontSize=this.handleIncreaseFontSize.bind(this);
        this.handleImageAdd=this.handleImageAdd.bind(this);
        this.handleSeriesChange=this.handleSeriesChange.bind(this);
        this.handleCodeAddition=this.handleCodeAddition.bind(this);
    }
    handleBold(){
        document.execCommand('bold', false, '');
    }
    handleItalics(){
        document.execCommand('italic', false, '');
    }
    handleUnderline(){
        document.execCommand('underline', false, '');
    }
    handleJustifyLeft(){
        document.execCommand('justifyLeft', false, '');
    }
    handleJustifyCentre(){
        document.execCommand('justifyCenter', false, '');
    }
    handleJustifyRight(){
        document.execCommand('justifyRight', false, '');
    }
    handleCut(){
        document.execCommand('cut', false, '');
    }
    handleUndo(){
        document.execCommand('undo', false, '');
    }
    handleRedo(){
        document.execCommand('redo', false, '');
    }
    handleOpenTextChange(e){
        this.setState({
            openingText:e.target.value
        })
    }
    handleSeriesChange(e){
        this.setState({
            Series:e.target.value
        })
    }
    handleImageAdd(){
        var src = prompt("Enter your src of image");
        var ht = prompt("Enter your height of image");
        var wdth = prompt("Enter your width of image");
        document.execCommand('insertHTML', 0, '<img src="' + src + '" style="height:'+ ht+';width:'+ wdth+'"/>');    }
    handleTitleChange(e){
        this.setState({
            title:e.target.value
        })
    }
    handleDecreaseFontSize(){
        if(this.state.fontSize>1){
            this.setState({
                fontSize:this.state.fontSize-1
            })
        }
        document.execCommand("fontSize", false, this.state.fontSize);
    }
    handleIncreaseFontSize(){
        if(this.state.fontSize<7)
        this.setState({
            fontSize:this.state.fontSize+1
        })
        document.execCommand("fontSize", false,  this.state.fontSize);
    }
    handleSubmitPost(){
        axios.post("https://know-search-backend.herokuapp.com/postArticle",{
            name:"Ujjwal Sharma",
            post: document.getElementsByClassName("editor")[0].innerHTML.toString(),
            time: Date.now().toString(),
            title:this.state.title,
            imgUrl:"https://imgur.com/B0y7hjc.jpg",
            openingText:this.state.openingText,
            Series:this.state.Series
        })
    }
    handleColorChange(){
        var color = prompt("Enter your color in hex ex:#f1f233");
        document.execCommand("foreColor", false, color);
    }
    handleCodeAddition(){
        var code = prompt("Enter your code");
        document.execCommand('insertHTML', 0, '<pre><code>"'+code+'"</code></pre>');    
    }
    render() { 
        return ( 
            <div>
                <Navbar />
                <Grid container spacing={3}>
                    <Grid container item xs={12} style={{borderStyle:"solid",borderColor:"black",borderWidth:"2px",marginLeft:"10vh",marginRight:"10vh",marginTop:"5vh",marginBottom:"3vh"}}>
                        <Grid item xs={12} style={{padding:"2vh"}}>
                            Enter the Title for the Post
                        </Grid>
                        <Grid item xs={12} style={{padding:"2vh"}}>
                        <TextField variant="outlined" placeholder="Enter Title" onChange={this.handleTitleChange}></TextField>
                        </Grid>
                        <Grid item xs={12} style={{padding:"1vh"}}>
                            Enter the Intro Text
                        </Grid>
                        <Grid item xs={12} style={{padding:"1vh"}}>
                        <TextField style={{width:"30vw"}} variant="outlined" placeholder="Opening Text" onChange={this.handleOpenTextChange}></TextField>
                        </Grid>
                        <Grid item xs={12} style={{padding:"1vh"}}>
                            Series Name
                        </Grid>
                        <Grid item xs={12} style={{padding:"1vh"}}>
                        <TextField style={{width:"20vw"}} variant="outlined" placeholder="Name of the Series" onChange={this.handleSeriesChange}></TextField>
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} style={{height:"130vh",borderStyle:"solid",borderColor:"black",borderWidth:"2px",margin:"2vh"}}>
                    <Grid item container xs={12} style={{backgroundColor:"#F9F9F9",paddingLeft:"5vh",paddingRight:"5vh",paddingTop:"2vh",paddingBottom:"2vh"}}>
                    <Grid item xs={1}>
                        <Button variant="contained" onClick={this.handleBold}><FormatBoldIcon/></Button>
                    </Grid>
                    <Grid item xs={1}>
                        <Button variant="contained" onClick={this.handleItalics}><FormatItalicIcon/></Button>
                    </Grid>
                    <Grid item xs={1}>
                        <Button variant="contained" onClick={this.handleUnderline}><FormatUnderlinedIcon /></Button>
                    </Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={1}>
                    <Button variant="contained" onClick={this.handleColorChange}><FormatColorFillIcon/></Button>
                    </Grid>
                    <Grid xs={1}>
                    <Button variant="contained" onClick={this.handleDecreaseFontSize}><TextRotateVerticalIcon /></Button>
                    </Grid>
                    <Grid xs={1}>
                    <Button variant="contained" onClick={this.handleIncreaseFontSize}><TextFormatIcon /></Button>
                    </Grid>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={1}>
                    <Button variant="contained" onClick={this.handleCodeAddition}>Code</Button>
                    </Grid>
                    <Grid item xs={1}>
                        <Button variant="contained" onClick={this.handleJustifyLeft}><FormatAlignLeftIcon/></Button>
                    </Grid>
                    <Grid item xs={1}>
                        <Button variant="contained" onClick={this.handleJustifyCentre}><FormatAlignCenterIcon/></Button>
                    </Grid>
                    <Grid item xs={1}>
                        <Button variant="contained" onClick={this.handleJustifyRight}><FormatAlignRightIcon/></Button>
                    </Grid>
                    <Grid item xs={2}>
                        <Button variant="contained" onClick={this.handleCut}>Cut</Button>
                    </Grid>
                    <Grid item xs={2}></Grid>
                    <Grid item xs={2}>
                        <Button variant="contained" onClick={this.handleUndo}><UndoIcon/></Button>
                    </Grid>
                    <Grid item xs={2}>
                        <Button variant="contained" onClick={this.handleRedo}><RedoIcon/></Button>
                    </Grid>
                    <Grid item xs={2}></Grid>
                    <Grid item xs={2}>
                    <Button variant="contained" onClick={this.handleImageAdd}><ImageIcon/></Button>
                    </Grid>
                    </Grid>
                    <Grid item xs={12} style={{marginTop:"1vh"}}>
                        <div className="editor" contentEditable style={{overflowY:"auto",height:"100vh",marginRight:`5vw`,marginLeft:`5vw`,borderStyle:"solid",borderColor:"black",borderWidth:"1px",padding:"1vh"}}>
                            <h1>Hello My Editor</h1>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <Button variant="contained" color="primary" onClick={this.handleSubmitPost}> SUBMIT </Button>
                    </Grid>
                    </Grid>
                </Grid>
            </div>
         );
    }
}
 
export default Editor;


// WEBPACK FOOTER //
// ./src/components/EDITOR/Editor.js